import {
  faAngleDown,
  faXmark
} from '@awesome.me/kit-5de77b2c02/icons/classic/solid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import cx from 'classnames'
import { FC, ReactNode, useCallback, useRef } from 'react'
import { noop } from 'rxjs'

import { useDropDownMenu } from '../../helpers/hooks/useDropDownMenu'
import DropdownList from '../DropdownList/DropdownList'
import { ListItem } from './GenericDropdownMenuMulti'

import styles from './GenericDropdownMenu.module.scss'

export interface Props {
  selectedItem: string
  setSelectedItem(st: string): void
  options: string[]
  selectId: string
  openRight: boolean
  className?: string
  placeholder?: string
  dropdownLabel?: string
  active?: boolean
  onRemove?: () => void
  customPanel?: ReactNode
  testId?: string
}

const GenericDropdownMenu: FC<Props> = ({
  selectedItem,
  setSelectedItem,
  options,
  openRight,
  className = '',
  placeholder,
  dropdownLabel,
  active,
  onRemove,
  customPanel,
  testId
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const { displayMenu, setDisplayMenu } = useDropDownMenu(ref)
  const isItemSelected = (item: string) => selectedItem === item
  const toggleSelected = useCallback(
    (item: string) => () => {
      setSelectedItem(item)
      setDisplayMenu(false)
    },
    [selectedItem]
  )
  const showOrHideDropdown = useCallback(() => {
    setDisplayMenu((value) => !value)
  }, [selectedItem])

  return (
    <div ref={ref} className={styles.dropdownContainer}>
      <div
        className={cx(
          styles.dropdown,
          active && styles.dropdownActive,
          className
        )}
        onClick={showOrHideDropdown}
        data-testid={testId}
      >
        {dropdownLabel && <span>{dropdownLabel}</span>}
        {(selectedItem || placeholder) && (
          <span className={styles.dropdownValue}>
            {selectedItem || placeholder}
          </span>
        )}
        <FontAwesomeIcon icon={faAngleDown} />
        {onRemove && (
          <button
            type="button"
            className={styles.removeButton}
            onClick={(e) => {
              e.stopPropagation()
              onRemove()
            }}
            aria-label="Remove filter"
            title="Remove filter"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        )}
      </div>
      {displayMenu &&
        (customPanel ? (
          <div className={styles.customPanel}>{customPanel}</div>
        ) : (
          <div className={cx(styles.menu, { [styles.menuRight]: openRight })}>
            <DropdownList
              onElementSelected={noop}
              elements={options.map((name) => ({
                id: name,
                label: (
                  <ListItem
                    id={name}
                    label={name}
                    selected={isItemSelected(name)}
                    toggleSingleOption={toggleSelected(name)}
                  />
                )
              }))}
            />
          </div>
        ))}
    </div>
  )
}
export default GenericDropdownMenu
